//import NotFoundData from "components/NotFoundData";
import styled from "@emotion/styled";
import { Row, Select, Image, Button } from "antd";
import { useAppDispatch, useAppSelector } from "store";
import { setLoading } from "store/slices/loadingSlice";
import NotFoundData from "components/NotFoundData";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import ModalExportOrderItemComplete from "./ModalExportOrderItemComplete";
import { GetDataOrderListData } from "services/interface";
import { useGetBankActiveList, useGetBankAllList } from "hooks/useFactory";
import OrderTableList from "./OrderTableList";
import SearchOrderForm from "../OrderTabsCard/SearchOrderForm";
import noImage from "assets/images/no-image.png";
const { Option } = Select;

interface OrderCompletedProps {
  data: GetDataOrderListData | undefined;
  isLoading: boolean;
  refetch: () => void;
  setSearchInput: Dispatch<SetStateAction<string>>;
  searchInput: string; // currentPage: number;
  IsHiddenPersonInfo?: boolean;
  setDateInput: Dispatch<SetStateAction<string>>;
  dateInput: string;
  setOpenForm?: Dispatch<SetStateAction<boolean>>;
}

const OrderCompleted: FC<OrderCompletedProps> = ({
  data,
  isLoading,
  refetch,
  setSearchInput,
  searchInput,
  IsHiddenPersonInfo,
  setDateInput,
  dateInput,
  setOpenForm
}) => {
  const dispatch = useAppDispatch();
  const factory_id = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { data: dataBank } = useGetBankActiveList(factory_id || "");
  const { contact } = useAppSelector((state) => state.auth);
  const userContactData = useAppSelector((state) => state.auth.contact);

  const [showModalExportExcel, setShowModalExportExcel] = useState(false);

  const childrenBank: React.ReactNode[] = [];
  dataBank?.data?.map((item) => {
    return childrenBank.push(
      <Option key={item.id} value={item.id}>
        <span style={{ fontSize: '12px' }}>
          <ImageWrapper>
            <Image src={item.image ?? noImage} alt={item.bank_name} preview={false} /> {item.bank_name} {item.account_no} {item.account_name}
          </ImageWrapper>
        </span>
      </Option>
    );
  });

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  }, [dispatch, isLoading]);

  const refetchData = () => {
    refetch();
  };

  return (
    <>
      <ModalExportOrderItemComplete
        open={showModalExportExcel}
        onClose={() => setShowModalExportExcel(false)}
        factoryName={userContactData?.name || "-"}
      />
      <WrapperAll>
        <HeadWrapper>
          <SearchOrderForm
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            setDateInput={setDateInput}
            dateInput={dateInput}
          />
          <Button type="primary" onClick={() => {
              //show modal export excel
              setShowModalExportExcel(true);
          }}>
            Export Excel
          </Button>
          {setOpenForm && contact?.code === "lunganek" && (
            <Button type="primary" onClick={() => {
              setOpenForm(true);
            }}>
              เพิ่มคำสั่งซื้อ
            </Button>
          )}
        </HeadWrapper>
        <CardWrapperTable>
          <OrderTableList
            data={data}
            childrenBank={childrenBank}
            refetchData={refetchData}
            IsHiddenPersonInfo={IsHiddenPersonInfo}
            factory_id={userContactData?.id || ''}
          />
        </CardWrapperTable>
      </WrapperAll>
    </>
  );
};

export default OrderCompleted;

// const PaginationWrapper = styled(Pagination)`
//   white-space: nowrap;
// `;
const WrapperAll = styled.div`
  padding: 10px 0px 10px 0px;
  background-color: #efefef;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`;
const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;
const OptionContent = styled.div`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled.div`
  margin-right: 8px;
  width: 20px;  
  height: 20px; 
  img {
    width: 100%;
    height: 100%;
  }
`;